// Common
import './lib/common/common.js';

// Load Web components
import '../components/kw-button-languages/kw-button-languages.js';
import '../components/kw-footer/kw-footer.js';
import '../components/kw-header/kw-header.js';
import '../components/kw-banner/kw-banner.js';
import '../components/kw-section/kw-section';
import '../components/kw-tab-list/kw-tab-list';
import '../components/kw-title/kw-title';
import '../components/kw-media-carousel/kw-media-carousel.js';

// Load libraries
import './lib/scroll/scroll.js';

import DataLanguage from './lib/data-language.js';
import dataBanner from './lib/dataBanner.js';
import dataBanners from '../json/uxBannerData.json';

const { lang } = document.querySelector('html');

const componentName = 'ux';

function banner() {
  const bannerData = document.getElementById('banner-ux');
  bannerData.innerHTML = `
          <kw-banner id="Banner" banner-size="ecommerce" animation-type="slide-toleft" change-interval="8">
              ${DataLanguage.dataLanguage(dataBanners.uxBannerData, lang).map(dataBanner.banner).join('')}
          </kw-banner>
    `;
}

function servicesAnimation() {
  const section = document.querySelector('#services');
  const wrapper = section.querySelector(`.${componentName}__services-inner`);

  const options = {
    threshold: 0.2,
  };
  /* eslint-disable-next-line */
  function callBack(entries, observer) {
    if (entries[0].isIntersecting) {
      wrapper.classList.add(`${componentName}__services-inner--visible`);
    }
  }

  const observerImages = new IntersectionObserver(callBack, options);
  observerImages.observe(section);
}

function methodologyAnimation() {
  const section = document.querySelector('#methodology-animation');
  const wrapper = section.querySelector(`.${componentName}__methodology-animation-inner`);

  const options = {
    threshold: 0.2,
  };
  /* eslint-disable-next-line */
  function callBack(entries, observer) {
    if (entries[0].isIntersecting) {
      wrapper.classList.add(`${componentName}__methodology-animation-inner--visible`);
    }
  }

  const observerImages = new IntersectionObserver(callBack, options);
  observerImages.observe(section);
}

function casesAnimation() {
  const section = document.querySelector('#case-studies');
  const wrapper = section.querySelector(`.${componentName}__cases-inner`);
  const image = section.querySelector(`.${componentName}__cases-image`);

  const options = {
    threshold: 0.4,
  };
  /* eslint-disable-next-line */
  function callBack(entries, observer) {
    if (entries[0].isIntersecting) {
      wrapper.classList.add(`${componentName}__cases-inner--visible`);
      image.classList.add(`${componentName}__cases-image--visible`);
    }
  }

  const observerImages = new IntersectionObserver(callBack, options);
  observerImages.observe(section);
}

function renderMethodologyAnimation() {
  const research = document.querySelector('#methodology-animation');
  research.innerHTML = /* html */ `
    <div class="${componentName}__methodology-animation-inner">
      <img width="551" height="391" src="/assets/images/ux/methodology-general.webp" alt="devops, software development, agile transformation, lean product design" class="${componentName}__methodology-general" />
      <img src="/assets/images/ux/magnifying-glass.svg" alt="lupa" class="${componentName}__magnifying-glass" />
      <div class="${componentName}__methodology-detail-wrapper">
        <img src="/assets/images/ux/methodology-detail.webp" alt="entender negocio, investigar, conceptualizar, idear, iteración, diseñar, acompañar a desarrollo, optimizar" class="${componentName}__methodology-detail" />
      </div>
    </div>
  `;
  methodologyAnimation();
}

function renderCases() {
  document.querySelector('kw-tab-list#ux').addEventListener('kw-tab-list:clicked', ({ detail }) => {
    const { index } = detail;
    const images = document.querySelectorAll(`.${componentName}__cases-image img`);
    images.forEach((image, imageIndex) => {
      // eslint-disable-next-line no-param-reassign
      image.hidden = imageIndex !== parseInt(index, 10);
    });
  });

  casesAnimation();
}

function handleLoadWindowFunctions() {
  banner();
  servicesAnimation();
  renderMethodologyAnimation();
  renderCases();
}

if (document.addEventListener) {
  window.addEventListener('load', handleLoadWindowFunctions);
}
